import { FormControl, InputLabel, Select, MenuItem, SelectChangeEvent } from "@mui/material";
import { t } from "i18next";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { GLOBALS } from "../../Models/Globals";
import { IComboSelector } from "./IComboSelector";




export const ComboSelector = ({

    Options,
    LabelKey,
    Label,
    OnSelectionChange,

}: IComboSelector) => {

    const { t, i18n } = useTranslation();
    const [currentOption, setCurrentOption] = useState<string>(GLOBALS.NO_SELECTED_OPTION.toString());

    const OnOptionChange = (event: SelectChangeEvent) => {

        const selectedValue: string = event.target.value as any;

        setCurrentOption(event.target.value);
        if (OnSelectionChange) {
            OnSelectionChange(selectedValue);
        }

    };


    return (
        <FormControl fullWidth>
            <InputLabel id={`label-combo-${LabelKey}`}>{Label}</InputLabel>
            <Select
                labelId={`label-combo-${LabelKey}`}
                id={`${LabelKey}`}
                value={currentOption}
                onChange={OnOptionChange}
            >
                <MenuItem value={GLOBALS.NO_SELECTED_OPTION}>{t('label-show-all')}</MenuItem>
                {
                    Options.map((option, index) => (
                        <MenuItem value={option} key={`combo-option-${LabelKey}-${index}`}>{option}</MenuItem>
                    ))
                }
            </Select>
        </FormControl>
    );

};